import moment from "moment";
import { getStatusLabel } from "../../../components/StatusChip";
import {
  convertUTCToLocalDateTime,
  getTimeZoneAbbreviation,
} from "../../../utils/dateUtils";

// Same Mon-Sun index convention as the editable drawer's schedule config
// (config.hibernate/wakeup.schedule.repeat is an array of included day
// indices, e.g. [0,1,2,3,4,5,6] for every day).
const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// [0,1,2,3,4,5,6] -> "daily"; [0,2,4] -> "Mon, Wed, Fri"; [] -> "".
export const formatDayLabel = (repeat) => {
  const days = Array.isArray(repeat) ? repeat : [];
  if (!days.length) return "";
  if (days.length >= 7) return "daily";
  return DAY_LABELS.filter((_, idx) => days.includes(idx)).join(", ");
};

// "2026-09-04T18:01:04" -> "2026-09-04T18:16:10" -> "15m"; falls back to "—"
// when either instant is missing or unparsable.
export const formatDuration = (startedAt, endedAt) => {
  if (!startedAt || !endedAt) return "—";
  const start = moment.utc(startedAt);
  const end = moment.utc(endedAt);
  if (!start.isValid() || !end.isValid()) return "—";
  const totalMinutes = Math.max(0, end.diff(start, "minutes"));
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  if (days) return `${days}d ${hours}h`;
  if (hours) return `${hours}h ${minutes}m`;
  return `${minutes || 1}m`;
};

// UTC instant -> "4 Sep 2026, 23:31" in the browser's local time, same
// conversion TimeCell/the Schedules card use. Caller appends the zone
// abbreviation once, rather than repeating it per instant.
export const formatLocalDateTime = (input) =>
  input && moment.utc(input).isValid()
    ? convertUTCToLocalDateTime(input, "D MMM YYYY, HH:mm")
    : "";

export { getTimeZoneAbbreviation };

export const sentenceCase = getStatusLabel;

const OWN_DOMAIN = "@tessell.com";

// Strips the shared workspace domain for display; other domains are kept in
// full so an external address is never silently truncated.
export const stripEmailDomain = (email) =>
  email && email.endsWith(OWN_DOMAIN)
    ? email.slice(0, -OWN_DOMAIN.length)
    : email;

export const copyToClipboard = async (text, onSuccess, onError) => {
  try {
    await navigator.clipboard.writeText(text ?? "");
    onSuccess?.();
  } catch (error) {
    onError?.();
  }
};
